import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import style from './index.module.scss';

function AnswerBody({ answerBody }) {
  return <div className={style['answer-body']}>{ReactHtmlParser(answerBody)}</div>;
}

AnswerBody.propTypes = {
  answerBody: PropTypes.string.isRequired,
};

export default AnswerBody;
